import { io } from 'socket.io-client';
import { toast } from 'react-toastify';

class SocketService {
  constructor() {
    this.socket = null;
    this.isLoggingOut = false;
  }

  connect(userId) {
    if (this.socket) return;
    
    const token = sessionStorage.getItem('authToken');
    if (!token) {
      console.error('❌ No auth token found for Almata socket connection');
      return;
    }
    
    this.socket = io('https://riskreport.almata.co.jp:3400', {
      path: '/socket.io/',
      transports: ['websocket', 'polling'],
      auth: {
        token: token
      },
      reconnection: true,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      reconnectionAttempts: 5
    });

    this.socket.on('connect', () => {
      console.log('✅ Almata socket connected:', this.socket.id);
      this.socket.emit('joinAlmataRoom', userId);
    });

    this.socket.on('connect_error', (error) => {
      console.error('❌ Almata socket connection error:', error);
    });

    this.socket.on('validationResult', (result) => {
      if (result.status === 401) {
        this.handleLogout(result.message);
      }
    });
  }

  startUserValidation(userId, userType) {
    this.connect(userId);
  }

  handleLogout(reason) {
    if (this.isLoggingOut) return;
    this.isLoggingOut = true;
    
    const message = reason === 'inactive' 
      ? 'Your account has been inactivated by the administrator.'
      : 'Your account has been suspended. Please contact administrator.';
    
    toast.error(message);
    
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      window.location.replace('/login');
    }, 2000);
  }

  stopValidation() {
    if (this.socket) {
      this.socket.disconnect();
      this.socket = null;
    }
  }
}

export default new SocketService();